import { render, staticRenderFns } from "./OpenCallPage.vue?vue&type=template&id=3779609f&scoped=true"
import script from "./OpenCallPage.vue?vue&type=script&lang=js"
export * from "./OpenCallPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3779609f",
  null
  
)

export default component.exports